import { combineReducers } from 'redux';

const activeScopeUserId = (state = '') => {
    const nextState = state;

    return nextState;
};

const canAccessLegacyConvert = (state = false) => {
    const nextState = state;

    return nextState;
};

const canChangePlan = (state = false) => {
    const nextState = state;

    return nextState;
};

const isAuthenticated = (state = false) => {
    const nextState = state;

    return nextState;
};

const isCopy = (state = false) => {
    const nextState = state;

    return nextState;
};

const isCoyoteCopy = (state = false) => {
    const nextState = state;

    return nextState;
};

const isCreate = (state = false) => {
    const nextState = state;

    return nextState;
};

const isFromAccount = (state = false) => {
    const nextState = state;

    return nextState;
};

const isLegacy = (state = false) => {
    const nextState = state;

    return nextState;
};

const userId = (state = '') => {
    const nextState = state;

    return nextState;
};

const userPlan = (state = '') => {
    const nextState = state;

    return nextState;
};

const userType = (state = '') => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    activeScopeUserId,
    canAccessLegacyConvert,
    canChangePlan,
    isAuthenticated,
    isCopy,
    isCoyoteCopy,
    isCreate,
    isFromAccount,
    isLegacy,
    userId,
    userPlan,
    userType,
});
